import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj from '@repo/ui/src/functions/build-link';

const GridItem = ({ item }) => {
  const { title, _meta, headerAsset } = item || {};
  const { deliveryKey } = _meta || {};
  const imgUrl =
    headerAsset?.length > 0
      ? buildImageSrc(headerAsset[0].image, 500, 1, 1)
      : buildImageSrc(null, 500, 1, 1);
  const linkObj = buildLinkObj({ link: deliveryKey });

  return (
    <Box bgcolor={'white'} height="100%" p={{ xs: 2, sm: 4 }}>
      <Box component="a" href={linkObj.href} display="flex" flexDirection="column" height="100%">
        <LazyLoadImage imgComponent={<img src={imgUrl} alt={title} width="100%" />} />
        <Box flex={1} mt={3}>
          <Typography component="h2" variant="h6">
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default GridItem;
